module.exports = __webpack_public_path__ + "static/media/browOuterUpLeft.db3a3be6.obj";